import { render, staticRenderFns } from "./YearMigration.vue?vue&type=template&id=1e8c53ba"
import script from "./YearMigration.vue?vue&type=script&lang=js"
export * from "./YearMigration.vue?vue&type=script&lang=js"
import style0 from "./YearMigration.vue?vue&type=style&index=0&id=1e8c53ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports